'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Badge } from '@workspace/ui/components/badge';
import { Button } from '@workspace/ui/components/button';
import { AlertCircle, CheckCircle2, CircleMinus, InfoIcon } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import type { ReactNode } from 'react';
import { CardMaintenanceAlert } from '@/components/wallet/card-maintenance';
import type { NativeCard } from '@/hooks/use-cards';

interface WalletCardProps {
  card: NativeCard;
  onSeeCard?: () => void;
}

interface CardState {
  label: string;
  variant: 'filled-light-green' | 'filled-light-blue-2' | 'filled-dark-orange' | 'filled-light-red';
  icon: ReactNode;
}

function getCardState(epsStatus: string | undefined): CardState {
  const status = epsStatus?.toLowerCase().trim();

  if (status === 'blockedbycustomer') {
    return { label: 'Frozen', variant: 'filled-light-blue-2', icon: <InfoIcon /> };
  }

  if (status === 'blockedbyissuer' || status === 'blockedbypartner') {
    return { label: 'Blocked', variant: 'filled-dark-orange', icon: <AlertCircle /> };
  }

  if (status === 'active') {
    return { label: 'Active', variant: 'filled-light-green', icon: <CheckCircle2 /> };
  }

  return { label: 'Inactive', variant: 'filled-light-red', icon: <CircleMinus /> };
}

export function WalletCard({ card }: WalletCardProps) {
  const cardState = getCardState(card.eps_status);

  return (
    <div className="bg-grey-25 dark:bg-grey-1000 flex w-full flex-col gap-8 rounded-[32px] p-6 shadow-[0px_17px_38px_0px_rgba(42,43,65,0.05)] sm:p-11">
      <div className="flex w-full flex-col gap-8">
        <div className="flex w-full flex-col gap-3">
          <div className="flex w-full flex-wrap items-center justify-between gap-3">
            <p className="text-grey-800 dark:text-grey-400 text-sm leading-6 font-medium">
              Native Teams card
            </p>
            <Badge variant={cardState.variant} size="lg" icon={cardState.icon}>
              {cardState.label}
            </Badge>
          </div>
          <p className="text-neutral-200 dark:text-neutral-100 text-xl leading-6 font-medium">
            Physical card
          </p>
        </div>

        <CardMaintenanceAlert titleOnly />

        <Image
          src="https://i.nativeteams.com/assets/app/wallet/cards/card-active-photo.webp"
          alt="Native Teams card"
          width={1024}
          height={526}
          className="h-auto max-h-[263px] w-full object-contain"
          priority
        />
      </div>
      <Button variant="primary" size="base" className="w-full sm:w-[200px]" asChild>
        <Link href={`/card/${card.id}`}>See my card</Link>
      </Button>
    </div>
  );
}
